import React, { useState, useRef, useMemo } from 'react';
import cn from 'classnames';
import ReactSwipe from 'react-swipe';
import Dots from '@wix/da-ds/pkg/pagination/Dots';
import ErrorBoundary from '../ErrorBoundary';
import s from './SwipeSlider.scss';
var MAX_CHILDREN_COUNT = 5;
var SwipeSlider = function (_a) {
    var _b = _a.startSlide, startSlide = _b === void 0 ? 0 : _b, indicatorsClassName = _a.indicatorsClassName, children = _a.children;
    var _c = useState(startSlide), activeIndex = _c[0], setActiveIndex = _c[1];
    var reactSwipeRef = useRef(null);
    var items = React.Children.count(children) > MAX_CHILDREN_COUNT
        ? React.Children.toArray(children).slice(0, MAX_CHILDREN_COUNT)
        : React.Children.toArray(children);
    // override swipe styles to use flexbox instead of floats which give us troubles with vertical stretching
    var swipeStyle = useMemo(function () { return ({
        container: { overflow: 'hidden' },
        wrapper: {
            position: 'relative',
            display: 'flex',
            alignItems: 'stretch',
            width: "".concat(100 * items.length, "%"),
        },
        child: {
            position: 'relative',
            left: startSlide > 0 ? "-".concat((100.0 / items.length) * startSlide, "%") : 0,
            flexBasis: "".concat(100.0 / items.length, "%"),
            flexShrink: 0,
            transitionProperty: 'transform',
        },
    }); }, [startSlide, items]);
    return (React.createElement("div", { className: s['root'] },
        React.createElement(ErrorBoundary, { debugComponent: "SwipeSlider" },
            React.createElement(ReactSwipe, { ref: function (swipeRef) { return (reactSwipeRef.current = swipeRef); }, childCount: items.length, style: swipeStyle, swipeOptions: {
                    startSlide: startSlide,
                    continuous: false,
                    callback: function (index) {
                        // this call fixes some jerkyness possibly caused by re-render before swipe ends
                        window.requestAnimationFrame(function () {
                            setActiveIndex(index);
                        });
                    },
                } }, items.map(function (child, index) { return (React.createElement("div", { key: child ? child['key'] : index }, child)); })),
            items.length > 1 && (React.createElement("div", { className: cn(s['indicators'], indicatorsClassName) },
                React.createElement(Dots, { total: items.length, current: activeIndex, onClick: function (index) {
                        setActiveIndex(index);
                        reactSwipeRef.current && reactSwipeRef.current.slide(index, 0);
                    } }))))));
};
SwipeSlider.displayName = 'SwipeSlider';
export default SwipeSlider;
//# sourceMappingURL=SwipeSlider.js.map